<template>
  <div class="nomess">
    <img :src="imgSrc" alt>
    <span>{{text}}</span>
  </div>
</template>
<script>
export default {
  name: 'noMess',
  props: {
    imgSrc: {
      type: String,
      default: require('../assets/images/icon_blank.png')
    },
    text: {
      type: String,
      default: '暂无数据'
    }
  },
  data () {
    return {};
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/common.less";
.nomess {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width:100%;
  height:100%;
  img {
    display: block;
    width:160px;
    height: 160px;
    margin-bottom: .32rem;
  }
  span {
    font-size:.32rem;
    line-height: .4rem;
    color: #999;
     margin-bottom: .68rem;
  }
}
</style>
